<template>
  <div class="hold-transition">
    <div class="modal fade" id="modal-form-mail">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Mensaje de Correo</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="subasta" class="modal-body">
            <div class="row justify-content-center">
              <button
                type="button"
                class="form-group btn btn-sm bg-navy"
                @click="sendMail()"
              >
                <i class="fas fa-paper-plane"></i>
                <br />
                <b> Enviar Email </b>
              </button>
            </div>
            <div class="row justify-content-center mb-3">
              <span
                v-if="subasta.estado_proceso == 2"
                class="badge badge-success"
                style="font-size: 12px"
              >
                <i class="fas fa-check"></i> El Correo ya ha sido enviado
              </span>
            </div>

            <div id="accordion">
              <div class="card card-lightblue mb-2">
                <div class="card-header p-2 pl-4">
                  <h4 class="card-title w-100">
                    <a
                      class="d-block w-100 collapsed"
                      data-toggle="collapse"
                      href="#destinatarios"
                      aria-expanded="false"
                    >
                      <i class="fas fa-at mr-2"></i>
                      Destinatarios
                    </a>
                  </h4>
                </div>
                <div
                  id="destinatarios"
                  class="collapse"
                  data-parent="#accordion"
                >
                  <div class="card-body table-responsive">
                    <table
                      class="table table-bordered table-striped table-hover table-sm text-nowrap"
                    >
                      <thead class="bg-dark">
                        <tr>
                          <th>Cliente</th>
                          <th>Correos</th>
                        </tr>
                      </thead>
                      <tbody v-for="item in subasta.clientes" :key="item.id">
                        <tr>
                          <td
                            v-if="
                              item.cliente !== null &&
                                item.cliente !== undefined
                            "
                            :rowspan="item.cliente.listas_correos.length + 1"
                          >
                            {{ item.cliente.razon_social }}
                          </td>
                          <td
                            v-if="
                              item.cliente !== null &&
                                item.cliente !== undefined
                            "
                          >
                            {{ item.cliente.email }}
                          </td>
                        </tr>
                        <tr
                          v-for="lista in item.cliente
                            ? item.cliente.listas_correos
                            : []"
                          :key="lista.id"
                        >
                          <td>{{ lista.correo }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card card-lightblue mb-2">
                <div class="card-header p-2 pl-4">
                  <h4 class="card-title w-100">
                    <a
                      class="d-block w-100 collapsed"
                      data-toggle="collapse"
                      href="#contenido"
                      aria-expanded="false"
                    >
                      <i class="fas fa-comment-alt mr-2"></i>
                      Contenido
                    </a>
                  </h4>
                </div>
                <div id="contenido" class="collapse" data-parent="#accordion">
                  <div class="card-body table-responsive text-secondary">
                    <p>Estimados Señores,</p>
                    <p>
                      Por medio del presente les invitamos a participar en el
                      proceso de Subasta para entregas de
                      {{ subasta.content_mail.productos }} para las semanas
                      {{ subasta.content_mail.semanas_con_year }}.
                    </p>
                    <p>
                      A continuación, presentamos la Programación de la Subasta:
                    </p>
                    <p>
                      <strong
                        >Subasta crudos Semanas
                        {{ subasta.content_mail.semanas_con_fecha }}</strong
                      >
                    </p>
                    <ul>
                      <li>
                        Invitación a ofertar para los volúmenes a entregar
                        durante las Semanas
                        {{ subasta.content_mail.semanas_con_fecha }}
                      </li>
                      <li>
                        Las ofertas serán recibidas como válidas hasta las
                        {{ subasta.content_mail.fecha_limite }}.
                      </li>
                      <li>
                        El día {{ subasta.content_mail.fecha_aceptacion }}, se
                        enviará nominaciones y liquidación para las ofertas
                        aceptadas.
                      </li>
                      <li>
                        Los proponentes adjudicados deberán encontrarse al día y
                        sin saldos pendientes por cruzar. Adicionalmente deberán
                        realizar los pagos anticipados que correspondan a los
                        volúmenes por entregar, de no existir saldos a favor
                        no se programarán entregas de producto.
                      </li>
                    </ul>
                    <p>
                      Posterior a la confirmación del ingreso correspondiente al
                      pago anticipado, programará y autorizará el despacho
                      de crudos a los clientes respectivos.
                    </p>
                    <p>
                      El volumen no retirado de la nominación correspondiente a
                      las semanas de las entregas no podrá ser recuperado.
                    </p>
                    <p>
                      A continuación presentamos las condiciones que aplican a
                      la presente subasta:
                    </p>
                    <table
                      class="table table-bordered table-striped table-sm mb-3"
                    >
                      <tbody>
                        <tr>
                          <th
                            class="col-3 text-center bg-dark"
                            :rowspan="subasta.productos.length + 1"
                          >
                            Producto
                          </th>
                        </tr>
                        <tr v-for="item in subasta.productos" :key="item.id">
                          <td>
                            {{ item.producto.nombre }} ({{ item.api }}° API y
                            {{ item.s }}% S)
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <th
                            class="col-3 text-center bg-dark"
                            :rowspan="subasta.productos.length + 1"
                          >
                            Punto de entrega
                          </th>
                        </tr>
                        <tr v-for="item in subasta.productos" :key="item.id">
                          <td>
                            {{ item.producto.nombre }}
                            {{ item.sitio ? `: ${item.sitio.dirreccion}` : "" }}
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <th
                            class="col-3 text-center bg-dark"
                            :rowspan="subasta.productos.length + 1"
                          >
                            Volumen
                          </th>
                        </tr>
                        <tr v-for="item in subasta.productos" :key="item.id">
                          <td>
                            {{ item.producto.nombre }}: Hasta
                            {{ item.cant_vh }} CTks/D (BD {{ item.volumen }})
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <th class="col-3 text-center bg-dark">Vigencia</th>
                          <td>
                            <div>
                              Semana <strong>S</strong> (Comprendida de lunes a
                              domingo).
                            </div>
                            <div>
                              Semanas
                              {{ subasta.content_mail.semanas_con_fecha }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <th
                            class="col-3 text-center bg-dark"
                            :rowspan="subasta.productos.length + 1"
                          >
                            Precio
                          </th>
                        </tr>
                        <tr v-for="item in subasta.productos" :key="item.id">
                          <td>
                            <div class="bg-olive pl-2 pr-2">
                              <strong>{{ item.producto.nombre }}</strong>
                            </div>
                            <ul class="mb-0">
                              <li v-if="item.precio_piso">
                                Precio Piso: Brent
                                <b>{{
                                  item.precio_piso != 0
                                    ? item.nSigno +
                                      " " +
                                      item.precio_piso +
                                      " " +
                                      item.nSignoMoneda
                                    : item.nSigno + " " + "Oferta"
                                }}</b>
                              </li>
                              <li>
                                Oferta:
                                <strong>X.XX {{ item.nSignoMoneda }}</strong
                                >$B
                              </li>
                              <li>Precio Oferta: Brent + Oferta</li>
                              <li>
                                Brent: Ice Brent Combined Monthly Rollover
                                Series 1st Month Close (LOc1) promedio de la
                                semana del programa de las entregas.
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <th class="col-3 text-center bg-dark">Pagos</th>
                          <td>
                            Pago anticipado en la semana
                            <strong>(S - 1)</strong> anterior a la semana de
                            inicio de las entregas <strong>(S)</strong> en base
                            al volumen nominado y el precio estimado
                            <i>(Ver fómula de precio)</i>.
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <th class="col-3 text-center bg-dark">
                            Inicio de Desapachos
                          </th>
                          <td>
                            El día lunes de la semana de entregas
                            <strong>S</strong>. (Sujeto a verificación de pago
                            de anticipo).
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      Para comenzar a subastar dar click en el siguiente enlace:
                      <a
                        href="https://localhost:8000/Comercializacion"
                        >click aquí</a
                      >
                    </p>
                    <p>
                      Las empresas adjudicadas deberán cumplir con el proceso de
                      inscripción y/o actualización de clientes de Frontera para
                      lo cual deberán enviar la documentación pertinente.
                    </p>
                    <p>
                      <i class="text-success"
                        >Las semanas Calendario se consideran de Lunes a
                        Domingo.</i
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

moment.locale("es-co");

export default {
  name: "SubastaModalCorreo",
  components: {},

  data() {
    return {
      subasta: null,
    };
  },

  methods: {
    getIndex(id = null) {
      if (id) {
        this.$parent.cargando = true;
        this.subasta = null;
        const me = this;
        axios
          .get("/api/com/subastas/" + id)
          .then((response) => {
            this.subasta = response.data;
            this.content_mail();
            this.$parent.cargando = false;
          })
          .catch(function(error) {
            me.$swal({
              icon: "error",
              title: "Ocurrió un error:" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            me.$parent.cargando = false;
          });
      }
    },

    content_mail() {
      moment.locale("es");
      // Se toman los productos ofertados para la subasta
      let lista_productos = [];
      this.subasta.productos.forEach((prod) => {
        // Se filtra el contenido de los productos a subastar
        let find_data = lista_productos.find(
          (dat) => dat == prod.producto.nombre
        );
        if (!find_data) {
          lista_productos.push(prod.producto.nombre);
        }

        // Se filtra el contenido de los volumenes de los productos a subastar
        let inicial = moment(prod.fecha_ini);
        let final = moment(prod.fecha_fin);
      });

      // Se filtran los productos en la lista
      let productos = "";
      lista_productos.forEach((list, index) => {
        productos +=
          lista_productos.length != index + 1
            ? lista_productos.length - 1 != index + 1
              ? `${list}, `
              : `${list} `
            : `, ${list}`;
      });

      // Se buscan las fechas para mostrar en el correo
      let inicial = moment(this.subasta.fecha_ini);
      let final = moment(this.subasta.fecha_fin);
      let plazo = moment(this.subasta.fecha_max_oferta);

      let semanas_con_year = null;
      if (inicial.year() == final.year()) {
        semanas_con_year = `${inicial.week()} y ${final.week()} de ${final.year()}`;
      } else {
        semanas_con_year = `${inicial.week()} de ${inicial.year()} y ${inicial.week()} de ${final.year()}`;
      }

      let semanas_con_fecha = null;
      if (inicial.year() == final.year()) {
        semanas_con_fecha = `${inicial.week()} y ${final.week()} (${inicial.format(
          "DD MMMM/YY"
        )} - ${final.format("DD MMMM/YY")})`;
      } else {
        semanas_con_fecha = `${inicial.week()} y ${final.week()} (${inicial.format(
          "DD MMMM/YY"
        )} - ${final.format("DD MMMM/YY")})`;
      }

      // Fecha limite
      const fecha_limite = `${plazo.format("HH:mm")} horas (${plazo.format(
        "A"
      )}) del ${plazo.format("dddd")} ${plazo.format("LL")}`;

      // Fecha nominacion y aceptacion
      let aceptacion = plazo.add(2, "DAYS");
      const fecha_aceptacion = `${aceptacion.format(
        "dddd"
      )} ${aceptacion.format("LL")}`;

      this.subasta.content_mail = {
        productos,
        semanas_con_year,
        semanas_con_fecha,
        fecha_limite,
        fecha_aceptacion,
      };
    },

    sendMail() {
      this.$parent.cargando = true;
      const me = this;
      axios({
        method: "POST",
        url: "/api/com/subastas/mail",
        data: this.subasta,
      })
        .then((response) => {
          if (!response.data.msg_error) {
            me.$refs.closeModal.click();
            me.$swal({
              icon: "success",
              title: response.data.msg,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            me.$swal({
              icon: "error",
              title: response.data.msg_error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
          me.$parent.cargando = false;
          me.$parent.getIndex();
        })
        .catch(function(error) {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error:" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.$parent.cargando = false;
        });
    },
  },
};
</script>
